var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
    fill: "url(#paint0_linear_1_3100)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4025 21.7287V21.7262C22.265 21.7362 21.5562 21.7787 19.975 21.7787C18.7125 21.7787 17.8237 21.7412 17.5112 21.7262V21.73C12.6512 21.5162 9.02375 20.67 9.02375 19.6575C9.02375 18.6462 12.6512 17.8 17.5112 17.5825V20.8875C17.8287 20.91 18.7387 20.9637 19.9962 20.9637C21.505 20.9637 22.2613 20.9012 22.4025 20.8887V17.585C27.2525 17.8012 30.8713 18.6475 30.8713 19.6575C30.8713 20.67 27.2525 21.5137 22.4025 21.7287ZM22.4025 17.2412V14.2837H29.17V9.77374H10.7438V14.2837H17.5112V17.24C12.0112 17.4925 7.875 18.5825 7.875 19.8875C7.875 21.1925 12.0112 22.2812 17.5112 22.535V32.0125H22.4025V22.5325C27.8938 22.28 32.02 21.1912 32.02 19.8875C32.02 18.5837 27.8938 17.495 22.4025 17.2412Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3100",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35CA9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26A17B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.bcdeb68611e7a3cfa8cc48b2c1f03a8d.svg";
export { ForwardRef as ReactComponent };